/**
 * newsletter.js — form nhận bản tin (footer, dải đăng ký trong blog).
 *
 * Bản tĩnh chưa có server: chặn submit, kiểm tra email bằng chính validation của
 * trình duyệt (input type=email required), rồi thay form bằng dòng xác nhận.
 * WP: xoá file này — form POST tới admin-post.php / shortcode Mailchimp như cũ.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form.matches || !form.matches('[data-newsletter]')) return;
        event.preventDefault();
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        var done = document.createElement('p');
        done.className = 'newsletter__done';
        done.setAttribute('role', 'status');
        done.innerHTML = '<i class="ph-fill ph-check-circle" aria-hidden="true"></i>';
        done.appendChild(document.createTextNode('Cảm ơn bạn! WINEBOSS sẽ gửi bản tin đầu tiên trong tuần này.'));
        form.parentNode.replaceChild(done, form);
    });
})();
